// グローバルに使いたいモジュール,関数はこちらで定義
// 残りはcomponents配下に配置してバンドルする方向性

$(function () {

  $(document).on("click", "#SPNavOpen", function () {
    $(this).toggleClass("Active");
    $("#Nav").toggleClass(function () {
      if ($(this).is(".Active")) {
        $(this).css({
          height: 0
        })
        return "Active";
      } else {
        $(this).css({
          height: $(window).height() - $("#Header").outerHeight()
        })
        return "Active";
      }
    });
  })
  if ($(window).width() <= 768) {
    $("body").css({
      "padding-top": $("#Header").outerHeight()
    })
    //
    $(document).on("click", ".Parent>a", function () {
      /*
      $(this).parent().toggleClass(function () {
        if ($(this).parent().is(".Active")) {
        } else {
          console.log($(this).parent());
          return "Active";
        }
      });
      */
      $(this).parent().toggleClass(function () {
        if ($(this).is(".Active")) {

          $(".SubNav", this).css({
            height: 0
          })
          return "Active";
        } else {
          $(".SubNav", this).css({
            height: $(".SubNav li", this).height() * $(".SubNav li", this).length
          })
          return "Active";
        }
      });
      return false;
    })
  } else {

    $('.Parent').on({
      'mouseenter': function () {
        $(this).children(".SubNav").css({
          top: $("#Nav").outerHeight()
        })
      },
      'mouseleave': function () {

        $(this).children(".SubNav").css({
          top: "48px"
        });
      }
    });
  }
})

$(window).on("load", function () {
  if ($(window).width() <= 768) {
    $("#Nav").css({
      top: $("#Header").outerHeight()
    })
  }
})
